import { newAxiosIns } from '@/libs/axios'

const apiSetStatusOrderAi = (orderId, status) => newAxiosIns.patch(`komship/api/v1/orders/komchat/${orderId}`, { status })

export default {
  apiSetStatusOrderAi,
}
